import type { AxiosResponse } from "axios";
import type {
  ELearningResponse,
  ELearningSubmission,
  ELearningResult,
} from "@/models/eLearning";
import { httpClient } from "./API"; // 既存のhttpClientを使用

/**
 * 理解度チェック研修プログラム取得
 * 登録されている「稼働管理・事故報告責任者」のメールアドレス一覧も含めて返す
 * @param id eラーニングID
 */
export const getELearningAPI = async (
  id: string
): Promise<AxiosResponse<ELearningResponse>> => {
  return httpClient.get(`core/internal/calgary/e-learning/${id}`);
};

/**
 * eラーニングの回答を提出
 * @param submission 回答データ
 */
export const submitELearningAPI = async (
  submission: ELearningSubmission
): Promise<AxiosResponse<ELearningResult>> => {
  return httpClient.post("core/internal/calgary/e-learning/submit", submission);
};

/**
 * 教材ファイルダウンロード用の署名付きURLを取得
 * @param id eラーニングID
 * @param fileName ファイル名
 */
export const getPresignedUrlAPI = async (
  id: string,
  fileName: string
): Promise<AxiosResponse<string>> => {
  return httpClient.get(`core/internal/calgary/e-learning/${id}/presignedUrl`, {
    params: { fileName },
  });
};
